<template>
    <div>
        <div class="card shadow">
            <div class="card-header bg-transparent">
                <div>
                    <h3 class="mb-0">
                        {{ $tc('message.controlDoctors', 1) }}
                    </h3>
                </div>
            </div>

            <div class="card-body">
                <div class="card">
                    <div class="card-body">
                        <h3 class="card-title text-center mb-0">
                            {{ fullName }}
                        </h3>
                    </div>
                    <div class="card-title">
                        <b-button class="mb-2 ml-4 btn btn-sm" variant="primary" @click="toAddInstitution">
                            {{ $t('message.add') }} {{ $tc('message.institutions', 1) }}
                        </b-button>
                    </div>
                    <b-container>
                        <div class="list-group list-group-flush">
                            <div class="row">
                                <div class="col-md-6 col-sm-6">
                                    <div>
                                        <div class="list-group-item">
                                            {{ $t('message.lastName') }}:
                                            <span class="font-weight-bold">
                                                {{ getValue(mDoctorUserInformation.nom) }}
                                            </span>
                                        </div>
                                    </div>

                                    <div>
                                        <div class="list-group-item">
                                            {{ $t('message.firstName') }}:
                                            <span class="font-weight-bold">
                                                {{ mDoctorUserInformation.prenom != null ? getValue(mDoctorUserInformation.prenom) : " "}}
                                            </span>
                                        </div>
                                    </div>

                                    <div>
                                        <div class="list-group-item">
                                            {{ $t('message.email') }}:
                                            <span class="font-weight-bold">
                                                {{ getValue(mDoctorUserInformation.email) }}
                                            </span>
                                        </div>
                                    </div>

                                    <div>
                                        <div class="list-group-item">
                                            {{ $t('message.phoneNumber') }}:
                                            <span class="font-weight-bold">
                                                {{ getValue(mDoctorUserInformation.telephone) }}
                                            </span>
                                        </div>
                                    </div>

                                    <div>
                                        <div class="list-group-item">
                                            {{ $t('message.orderNumber') }}:

                                            <span class="font-weight-bold">
                                                {{(mDoctor.numero_ordre == null || mDoctor.numero_ordre == "null") ? '0000' :mDoctor.numero_ordre   }}
                                            </span>
                                        </div>
                                    </div>

                                    <div>
                                        <div class="list-group-item">
                                            {{ $t('message.civility') }}:

                                            <span class="font-weight-bold">
                                                {{ getValue(mDoctor.civilite) }}
                                            </span>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-md-6 col-sm-6">
                                    <div>
                                        <div class="list-group-item">
                                            {{ $t('message.nationality') }}:

                                            <span class="font-weight-bold">
                                                {{ getValue(mDoctorUserInformation.nationalite) }}
                                            </span>
                                        </div>
                                    </div>
                                    <div>
                                        <div class="list-group-item">
                                            {{ $tc('message.cities', 1) }}:

                                            <span class="font-weight-bold">
                                                {{ getValue(mDoctorUserInformation.ville) }}
                                            </span>
                                        </div>
                                    </div>

                                    <div>
                                        <div class="list-group-item">
                                            {{ $tc('message.countries', 1) }}:

                                            <span class="font-weight-bold">
                                                {{ getValue(mDoctorUserInformation.pays) }}
                                            </span>
                                        </div>
                                    </div>

                                    <div>
                                        <div class="list-group-item">
                                            {{ $t('message.street') }}:

                                            <span class="font-weight-bold">
                                                {{ getValue(mDoctorUserInformation.quartier) }}
                                            </span>
                                        </div>
                                    </div>

                                    <div>
                                        <div class="list-group-item">
                                            {{ $t('message.zipCode') }}:

                                            <span class="font-weight-bold">
                                                {{ getValue(mDoctorUserInformation.code_postal) }}
                                            </span>
                                        </div>
                                    </div>

                                    <div>
                                        <div class="list-group-item">
                                            {{ $t('message.address') }}:

                                            <span class="font-weight-bold">
                                                {{ getValue(mDoctorUserInformation.adresse) }}
                                            </span>
                                        </div>
                                    </div>
                                </div>

                                <b-row>
                                    <b-col col sm="12">
                                        <div class="list-group-item">
                                            {{ $t('message.signature') }}:

                                            <span class="font-weight-bold">
                                                <img :src="image" class="card-img-top" alt="Image does not show">
                                            </span>
                                        </div>
                                    </b-col>
                                </b-row>
                            </div>
                        </div>

                    </b-container>

                    <b-container>
                        <b-row class="justify-content-sm-center" v-if="can">
                            <div class="card-footer text-right">
                                <b-button variant="primary" @click="updateDoctor">
                                    {{ $t('message.edit') }}
                                </b-button>

                                <b-button v-b-modal.delete-modal variant="danger">
                                    {{ $t('message.delete') }}
                                </b-button>
                            </div>
                        </b-row>
                    </b-container>

                    <b-container>
                        <b-row>
                            <b-col col sm="12">
                                <hr>
                                <h3 class="text-center">{{ $tc('message.institutions', 2) }}</h3>
                                <vue-good-table
                                        id="allergie"
                                        v-if="mInstitutions"
                                        :columns="mInstitutionsColumns"
                                        :rows="mInstitutions"
                                        :search-options="enabled"
                                        :pagination-options="paginationOptions"
                                        :select-options="{
                                            enabled: true,
                                          }"
                                        ref="institution-table"
                                >
                                    <div slot="selected-row-actions" v-if="hasGestionnaireRole || hasAdminRole">
                                        <button @click="removeEtablissement">Supprimer</button>
                                    </div>
                                </vue-good-table>
                            </b-col>
                        </b-row>
                    </b-container>

                    <b-modal
                            id="delete-modal"
                            size="sm"
                            header-bg-variant="danger"
                            header-text-variant="light"
                            :title="$t('message.delete') + ' ' + $tc('message.controlDoctors', 1)"
                            hide-footer
                    >
                        <div class="d-block text-center">
                            <h3>{{ $t('message.delete') }} {{ fullName }}?</h3>
                        </div>

                        <div class="d-block float-right">
                            <b-button variant="danger" @click="deleteDoctor">
                                {{ $t('message.delete') }}
                            </b-button>

                            <b-button variant="secondary" @click="$bvModal.hide('delete-modal')">
                                {{ $t('message.cancel') }}
                            </b-button>
                        </div>
                    </b-modal>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import moment from 'moment';
    import AppConfig from '../../constants/AppConfig';
    import _ from 'lodash';


    export default {
        name: "ControlDoctor",

        computed: {
            ...mapGetters(["controlDoctor",'hasAdminRole','hasAssistante',
                'hasGestionnaireRole']),

            can:function(){
                return this.hasAdminRole || this.hasGestionnaireRole || this.hasAssistante;
            },

            mDoctor: function() {
                return this.controlDoctor;
            },

           mInstitutions:function(){
                return this.mDoctor.etablissements;
            },

            mDoctorUserInformation:function(){
                if (typeof this.mDoctor.user == 'object'){
                    return this.mDoctor.user;
                }
                return [];
            },

            fullName:function () {
                let prenom  = this.mDoctorUserInformation.prenom != null ? this.mDoctorUserInformation.prenom : "";
                prenom = prenom.toLowerCase();

                return (this.getValue(this.mDoctorUserInformation.nom)).toUpperCase() + " "+ prenom.charAt(0).toUpperCase() + prenom.substring(1);
            },

            image: function() {
                return AppConfig.imgUrl + '/public/storage/' + this.mDoctor.signature;
            }

        },

        data() {
            return {
                doctor_id: this.$route.params.doctor,

                mInstitutionsColumns:[
                    {
                        label: this.$i18n.t('message.name'),
                        field: 'name',
                    },
                    {
                        label: 'Description',
                        field: 'description',
                    },
                ],

                paginationOptions:{
                    enabled: true,
                    mode: 'records',
                    perPageDropdown: [3, 6, 10]
                },

                enabled:{enabled: true},
            }
        },

        methods: {
            toAddInstitution() {
                this.$router.push({ name: 'add-doctor-institution', params: { doctor: this.doctor_id } })
            },

            removeEtablissement() {
                let etablissementId=[];
                _.forEach(this.$refs['institution-table'].selectedRows,function (row) {
                    etablissementId.push(row.id)

                });
                let args = {
                    medecin_id: this.controlDoctor.slug,
                    etablissement_id:etablissementId
                };

                let successMessage = this.$i18n.t('message.institutionDeleted');
                let errorMessages = {
                    generic: this.$i18n.t('message.genericError'),
                    error: this.$i18n.t('message.error')
                };

                this.$store.dispatch('removeControlDoctorInstitution', { args, successMessage, errorMessages });
            },

            getDoctor() {
                let args = {
                    doctor: this.doctor_id
                };

                this.$store.dispatch("getControlDoctor", { args });
            },

            formattedDate(date) {
                return moment(date).format('DD-MM-YYYY HH:mm');
            },

            updateDoctor() {
                this.$router.push({ name: 'edit-control-doctor', params: { doctor: this.doctor_id } });
            },

            deleteDoctor() {
                let self = this;
                let args = {
                    doctor: this.doctor_id
                };

                let successMessage = this.$i18n.t('message.controlDoctorDeleted');
                let errorMessages = {
                    generic: this.$i18n.t('message.genericError'),
                    error: this.$i18n.t('message.error')
                };

                this.$store.dispatch('deleteControlDoctor', { args, index: self.doctor_id, successMessage, errorMessages }).then(() => {
                    self.$bvModal.hide('delete-modal');
                    this.$router.back();

                });
            },
            getValue(item){
                if (typeof item != "undefined"){
                    return item;
                }else{
                    return "";
                }
            },
        },

        mounted() {
            this.getDoctor();
        }
    }
</script>

<style scoped>

</style>